import { CircleAlert, CircleCheck, X } from "lucide-react";
import { useSyncExternalStore } from "react";

type Toast = { id: number; kind: "error" | "ok" | "info"; message: string };
let toasts: Toast[] = [];
let nextId = 1;
const listeners = new Set<() => void>();
const set = (next: Toast[]) => {
  toasts = next;
  for (const fn of listeners) fn();
};
const push = (kind: Toast["kind"], message: string, ms = kind === "error" ? 6000 : 2500) => {
  const id = nextId++;
  set([...toasts.slice(-3), { id, kind, message }]);
  setTimeout(() => set(toasts.filter((t) => t.id !== id)), ms);
};

export const toast = {
  error: (m: string) => push("error", m),
  ok: (m: string) => push("ok", m),
  info: (m: string) => push("info", m),
};

export function Toaster() {
  const list = useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => toasts,
  );
  return (
    <div className="pointer-events-none fixed right-4 bottom-4 z-50 flex w-80 flex-col gap-2">
      {list.map((t) => (
        <div key={t.id} className="pointer-events-auto flex items-start gap-2 rounded-lg border border-line bg-surface px-3 py-2.5 shadow-pop">
          {t.kind === "error" ? <CircleAlert className="mt-0.5 size-4 shrink-0 text-danger" /> : <CircleCheck className="mt-0.5 size-4 shrink-0 text-ok" />}
          <div className="flex-1">{t.message}</div>
          <button type="button" className="text-faint hover:text-text" onClick={() => set(toasts.filter((x) => x.id !== t.id))}>
            <X className="size-3.5" />
          </button>
        </div>
      ))}
    </div>
  );
}
